import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, Col, Row } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReactPaginate from 'react-paginate'
import './report.css';
import SelectDate from '../../component/element/SelectDate'
import SelectObject from '../../component/element/SelectObject'
import PrintButtons from '../../component/element/PrintButtons'

const mockJson = {
  shopList: [
    {
      shopId: '1xx',
      shopName: 'จอหอคาร์เพนท์1'
    }, {
      shopId: '2xx',
      shopName: 'จรูญยนต์1'
    }
  ],

  purchaseList: [
    {
      purchaseDate: '07/05/2017',
      detail: '',
      registrationNo: 'กข 1234',
      ownerName: 'บ.ไทยน้ำทิพย์',
      summaryAmount: '5000',
      billingNo: 'x2330092',
      responsibleList: [
        {
          name: 'สต็อกอู่',
          quantity: '10',
          price_per_unit: '5',
          amount: '2',
          discount: '3',
          totalAmount: '2'
        }, {
          name: 'อู่',
          quantity: '3',
          price_per_unit: '5',
          amount: '9',
          discount: '',
          totalAmount: '9'
        }, {
          name: 'อู่ - ลูกค้า',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }, {
          name: 'KTB',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }, {
          name: 'โกลเด้นท์',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }, {
          name: 'ปิ่นทิพย์',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }, {
          name: 'คุณเกษม',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }, {
          name: 'อู่พงษ์เจริญกลการ',
          quantity: '',
          price_per_unit: '',
          amount: '',
          discount: '',
          totalAmount: ''
        }
      ]
    }
  ],
  shopId: '1xx',
  shopName: 'จอหอคาร์เพนท์1',
  updatedDate: '2017',
  listCount: 100
}



const getPurchaseListMock = () => {
  const responsibleListMock = [
    {
      name: 'สต็อกอู่',
      quantity: '10',
      price_per_unit: '5',
      amount: '2',
      discount: '3',
      totalAmount: '2'
    }, {
      name: 'อู่',
      quantity: '3',
      price_per_unit: '5',
      amount: '9',
      discount: '',
      totalAmount: '9'
    }, {
      name: 'อู่ - ลูกค้า',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }, {
      name: 'KTB',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }, {
      name: 'โกลเด้นท์',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }, {
      name: 'ปิ่นทิพย์',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }, {
      name: 'คุณเกษม',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }, {
      name: 'อู่พงษ์เจริญกลการ',
      quantity: '',
      price_per_unit: '',
      amount: '',
      discount: '',
      totalAmount: ''
    }
  ]

  const responsibleListGroupMock = new Array(3).fill(null).map((v) =>
    JSON.parse(JSON.stringify(responsibleListMock)
    ))

  responsibleListGroupMock.forEach((responsibleList) => (
    responsibleList.forEach((responObj) => (
      responObj.totalAmount = Math.round(Math.random() * 1000 + 1)
    ))
  ))

  return responsibleListGroupMock.map((responsibleList) => (
    {
      purchaseDate: '07/05/2017',
      detail: '',
      registrationNo: 'กข 1234',
      ownerName: 'บ.ไทยน้ำทิพย์',
      summaryAmount: '5000',
      billingNo: 'x2330092',
      responsibleList: responsibleList
    }
  ))
}

let newMock = JSON.parse(JSON.stringify(mockJson))
newMock.purchaseList = getPurchaseListMock()
let newMock2 = JSON.parse(JSON.stringify(newMock))
newMock2.shopId = '2xx'
newMock2.shopName = 'จรูญยนต์1'
newMock2.purchaseList = getPurchaseListMock()
// const allMock = [newMock, newMock2]

class ReportShopPurchaseOrder extends Component {

  constructor(...args) {
    super(...args)
    this.state = {
      itemPerPage: 20,
      pageCount: 1,
      activePage: 1,
      month: momentHelper.getMonth(),
      year: momentHelper.getYear(),
      data: newMock
    }
  }

  renderFreezedTable() {
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center' style={{ lineHeight: '100px' }}>วดป</th>
            <th className='text-center' style={{ lineHeight: '100px' }}>รายการ</th>
            <th className='text-center' style={{ lineHeight: '100px' }}>ทะเบียนรถ</th>
            <th className='text-center' style={{ lineHeight: '100px' }}>เจ้าของรถ</th>
          </tr>
        </thead>
        <tbody>
          {this.renderFreezedBody()}
        </tbody>
        <tfoot>
          {this.renderCarOwnerFooter()}
        </tfoot>
      </table>
    )
  }

  renderFreezedBody() {
    const excludedColumns = ['billingNo', 'summaryAmount', 'responsibleList']
    return tableHelper.renderRows(this.state.data.purchaseList, excludedColumns)
  }

  renderResponsibleHeader() {
    return this.state.data.purchaseList[0].responsibleList.map((obj, idx) => {
      const keys = Object.keys(obj)
      return (
        <th key={idx} className='text-center' colSpan={keys.length - 1}>{obj.name}</th>
      )
    })
  }

  renderResponsibleDetail() {
    return this.state.data.purchaseList[0].responsibleList.map((obj, responIdx) => {
      const columnNames = ['จำนวน', 'ราคา', 'มูลค่า', 'ลด3%', 'สุทธิ']
      const columns = columnNames.map((val, cid) => (
        <th key={responIdx * 10 + cid}>{val}</th>
      ))
      return columns
    })
  }

  renderCarOwnerBody() {
    return this.state.data.purchaseList.map((purchaseObj, pid) => {
      const responVals = purchaseObj.responsibleList.map((responObj, rid) => {
        const responKeys = Object.keys(responObj).filter((k) => k !== 'name')
        return responKeys.map((k, kid) => (
          responObj[k]
        ))
      })

      const purchaseVals = Object.keys(purchaseObj).filter((k) => (
        k === 'billingNo' || k === 'summaryAmount'
      )).map((k) => (
        purchaseObj[k]
      ))

      const responValsFlatten = responVals.reduce((acc, arr) => {
        return acc.concat(arr)
      }, [])

      const tds = responValsFlatten.concat(purchaseVals).map((v, vid) => (
        <td key={pid * 10 + vid}>{v}</td>
      ))

      return <tr key={pid}>{tds}</tr>
    })
  }

  renderCarOwnerFooter() {
    const excludedColumn = ['billingNo', 'summaryAmount', 'responsibleList']
    const totalColumnLen = Object.keys(this.state.data.purchaseList[0]).filter((k) => (
      excludedColumn.indexOf(k) === -1
    )).length
    return (
      <tr>
        <th className='text-center' colSpan={totalColumnLen}>รวมยอดทั้งสิ้น</th>
      </tr>
    )
  }

  renderCarOwnerSummary() {
    const responsibleList = this.state.data.purchaseList[0].responsibleList
    const responsibleListColSpan = Object.keys(responsibleList[0]).length - 1
    // sum of totalAmount
    const sumTotalAmount = this.state.data.purchaseList.reduce((acc, purchaseObj) => (
      purchaseObj.responsibleList.map((responObj, rid) => (
        acc[rid] + responObj.totalAmount * 1
      ))
    ), new Array(responsibleList.length).fill(0))
    // sum of summaryAmount
    const sumSummaryAmount = this.state.data.purchaseList.reduce((acc, purchaseObj) => (
      acc + purchaseObj.summaryAmount * 1
    ), 0)
    const allSum = sumTotalAmount.concat(sumSummaryAmount)
    // a list of th
    const responsibleListTHs = allSum.map((v, i) => (
      i < allSum.length - 1
        ? <th key={i} className='text-right' colSpan={responsibleListColSpan}>{v}</th>
        : <th key={i} className='text-center'>{v}</th>
    ))

    return (
      <tr>{responsibleListTHs}</tr>
    )
  }

  renderScrollableTable() {
    const numCarOwner = this.state.data.purchaseList[0].responsibleList.length
    const numDetailColumns =
      Object.keys(this.state.data.purchaseList[0].responsibleList[0]).length - 1
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center' colSpan={numCarOwner * numDetailColumns}>เจ้าของรถ</th>
            <th className='text-center' rowSpan={3}>มูลค่า</th>
            <th className='text-center' rowSpan={3}>เลขที่บิล</th>
          </tr>
          <tr>
            {this.renderResponsibleHeader()}
          </tr>
          <tr>
            {this.renderResponsibleDetail()}
          </tr>
        </thead>
        <tbody>
          {this.renderCarOwnerBody()}
        </tbody>
        <tfoot>
          {this.renderCarOwnerSummary()}
        </tfoot>
      </table>
    )
  }

  renderTable() {
    return (
      <div>
        <div className='col-md-1 col-div-freeze padding-none'>
          {this.renderFreezedTable()}
        </div>
        <div className='col-md-10 col-div-free padding-none display-overflow'>
          {this.renderScrollableTable()}
        </div>
      </div>
    )
  }

  onMonthChange(val) {
    this.setState({
      month: val.value
    })
    // next... load data
  }

  onYearChange(val) {
    this.setState({
      year: val.value
    })
    // next... load data
  }

  onClientChange(val) {
    console.log(val)
    this.setState({
      data: val.value === '1xx' ? newMock : newMock2
    })
    // load client data
  }

  onPageChange(page) {
    console.log('pageChagne', page)
  }

  renderToolbar() {
    return (
      <Form inline>
        <SelectDate
          year={this.state.year}
          month={this.state.month}
          onMonthChange={this.onMonthChange.bind(this)}
          onYearChange={this.onYearChange.bind(this)}
        />
        <div style={{ width: '180px', display: 'inline-block' }}>
          <SelectObject
            value={this.state.data.shopId}
            objectList={this.state.data.shopList}
            onChange={this.onClientChange.bind(this)}
          />
        </div>
      </Form>
    )
  }

  renderPaging() {
    let { pageCount, activePage } = this.state
    return (

      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />

        </Col>
      </Row>

    )
  }

  render() {
    const title = 'สรุปรายการสั่งซื้อร้าน ' + this.state.data.shopName

    return (
      <Box>
        <Box.Header border={true}>
          <Box.Title>{title}</Box.Title>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          {this.renderPaging()}
        </Box.Body>
      </Box>
    )

  }
}

export default ReportShopPurchaseOrder;



// WEBPACK FOOTER //
// ./src/view/report/ReportShopPurchaseOrder.js